import visitorService from "reduxStore/service/visitorService";
import {
  VISITOR_DETAIL,
  VISITOR_LIST,
  EDIT_VISITOR,
  VISITOR_FORM_UPDATE,
  ADD_VISITOR,
  BULK_VERIFY_VISITOR_LIST,
  VISITOR_STATUS_UPDATE,
  VERIFY_VISITOR_DETAIL,
  BULK_VERIFY_VISIT_FORM,
  EDIT_UNVERIFYCSV_VISIT,
  BULK_IMAGE_UPLOAD,
  BULK_CSV_UPLOAD,
  VISITOR_MOBILE_CHECK,
  REMOVE_VISITOR_MOBILE_CHECK,
  VISITOR_LISTS,
  CHECK_REFERENCE_EXIST
} from "reduxStore/types";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import { downloadURI } from "utils/utils";
import {
  BULK_VISITOR_DETAIL,
  BULK_VISITOR_LIST,
  BULK_VISIT_FORM,
} from "../types";

// Visitor_Module
export const visitorList = (item) => async (dispatch) => {
  try {
    const res = await visitorService.visitorList(item);
    if (res.data.status === 200) {
      dispatch({
        type: VISITOR_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: VISITOR_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const visitorDetail = (item) => async (dispatch) => {
  try {
    const res = await visitorService.visitorDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: VISITOR_DETAIL,
        payload: res.data,
      });
    } else {
      dispatch({
        type: VISITOR_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const editVisitor = (item) => async (dispatch) => {
  try {
    const res = await visitorService.editVisitor(item);
    if (res.data.status === 200) {
      dispatch({
        type: EDIT_VISITOR,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const addVisitor = (item) => async (dispatch) => {
  try {
    const res = await visitorService.addVisitor(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_VISITOR,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const visitorMobileCheck = (item) => async (dispatch) => {
  try {
    const res = await visitorService.visitorMobileCheck(item);
    if (
      res.data.status === 200 ||
      res.data.status === 201 ||
      res.data.status === 202
    ) {
      dispatch({
        type: VISITOR_MOBILE_CHECK,
        payload: res.data,
      });
      // successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const removeVisitorMobileCheck = () => async (dispatch) => {
  try {
    dispatch({
      type: REMOVE_VISITOR_MOBILE_CHECK,
      payload: null,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

// Bulk_Upload_Document
export const addBulkImageUpload = (item) => async (dispatch) => {
  try {
    const res = await visitorService.addBulkImageUpload(item);
    if (res.data.status === 200) {
      dispatch({
        type: BULK_IMAGE_UPLOAD,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const addBulkCsvUpload = (item) => async (dispatch) => {
  try {
    const res = await visitorService.addBulkCsvUpload(item);
    if (res.data.status === 200) {
      dispatch({
        type: BULK_CSV_UPLOAD,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const downloadCSVFIle = (item) => async (dispatch) => {
  try {
    const res = await visitorService.downloadCSVFile(item);
    if (res.data.status === 200) {
      downloadURI(
        res.data.data.base_url + res.data.data.file,
        res.data.data.file
      );
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

//when_property_not_select_in_public_lead
export const addVisitProperty = (item) => async (dispatch) => {
  try {
    const res = await visitorService.addVisitProperty(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_VISITOR,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const removeVistor = (item) => async (dispatch) => {
  try {
    dispatch({
      type: ADD_VISITOR,
      payload: null,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const visitorFormUpdate = (item) => async (dispatch) => {
  try {
    dispatch({
      type: VISITOR_FORM_UPDATE,
      payload: item,
    });
  } catch (e) {
    // const { response = strings.initialError } = e;
    // unAuthorizedError(response.data);
  }
};

// New_Upload_Module
export const bulkVisitList = (item) => async (dispatch) => {
  try {
    const res = await visitorService.bulkVisitList(item);
    if (res.data.status === 200) {
      dispatch({
        type: BULK_VISITOR_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: BULK_VISITOR_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const bulkVisitDetail = (item) => async (dispatch) => {
  try {
    const res = await visitorService.bulkVisitDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: BULK_VISITOR_DETAIL,
        payload: res.data,
      });
    } else {
      dispatch({
        type: BULK_VISITOR_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const bulkVisitForm = (item) => async (dispatch) => {
  try {
    dispatch({
      type: BULK_VISIT_FORM,
      payload: item,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

// Verify_Lead_Module
export const bulkVerifyVisitList = (item) => async (dispatch) => {
  try {
    const res = await visitorService.bulkVerifyVisitList(item);
    if (res.data.status === 200) {
      dispatch({
        type: BULK_VERIFY_VISITOR_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: BULK_VERIFY_VISITOR_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const visiorStatusUpdate = (item) => async (dispatch) => {
  try {
    const res = await visitorService.visitStatusUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: VISITOR_STATUS_UPDATE,
        payload: res.data,
      });
      // successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const verifyVisitDetail = (item) => async (dispatch) => {
  try {
    const res = await visitorService.verifyVisitDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: VERIFY_VISITOR_DETAIL,
        payload: res.data,
      });
    } else {
      dispatch({
        type: BULK_VERIFY_VISITOR_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const bulkVerifyVisitForm = (item) => async (dispatch) => {
  try {
    dispatch({
      type: BULK_VERIFY_VISIT_FORM,
      payload: item,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const editUnverfiyCsvVisit = (item) => async (dispatch) => {
  try {
    const res = await visitorService.editUnverfiyCsvVisit(item);
    if (res.data.status === 200) {
      dispatch({
        type: EDIT_UNVERIFYCSV_VISIT,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getVisiterList = (item) => async (dispatch) => {
  try {
    const res = await visitorService.getVisitorList(item);
    if (res.data.status === 200) {
      dispatch({
        type: VISITOR_LISTS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: VISITOR_LISTS,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const checkReferenceNmbrExist = (item)=> async (dispatch) => {
  try {
 
    const res = await visitorService.checkReferenceNmbrExist(item);
    if (
      res.data.status === 200 ||
      res.data.status === 201 ||
      res.data.status === 202
    ) {
      dispatch({
        type: CHECK_REFERENCE_EXIST,
        payload: res.data,
      });
    
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};